const trackingId = 'G-YX8XYYP5VL';
function initializeAnalytics() {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
    }
    if (document.querySelector('script[data-gtag-id="' + trackingId + '"]')) {
        return;
    }
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag(...args) {
        window.dataLayer.push(args);
    };
    window.gtag('js', new Date());
    window.gtag('config', trackingId, { send_page_view: false });
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + trackingId;
    script.setAttribute('data-gtag-id', trackingId);
    document.head.appendChild(script);
}
initializeAnalytics();
export {};
